import { createAction, createSlice } from '@reduxjs/toolkit';
import { AccountWithdrawalRelationshipRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export interface AccountsWithdrawalRelationshipsState {
    [key: string]: {
        [key: string]: AccountWithdrawalRelationshipRecord;
    };
}

const initialState: AccountsWithdrawalRelationshipsState = {};

const initialLoadAction = createAction<{ accountsWithdrawalRelationships: AccountsWithdrawalRelationshipsState }>('InitialLoad');
const accountWithdrawalRelationshipRecordAction = createAction<AccountWithdrawalRelationshipRecord>(
    CoreMsgTypes.AccountWithdrawalRelationshipRecord
);

const accountsWithdrawalRelationshipsSlice = createSlice({
    name: 'accountsWithdrawalRelationships',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (_state, action) => {
                return action.payload.accountsWithdrawalRelationships;
            })
            .addCase(accountWithdrawalRelationshipRecordAction, (state, action) => {
                const { AccountId, AccountWithdrawalDataId } = action.payload;
                if (action.payload.IsDeleted) {
                    if (state[AccountId] && state[AccountId][AccountWithdrawalDataId]) {
                        delete state[AccountId][AccountWithdrawalDataId];
                        if (Object.keys(state[AccountId]).length === 0) {
                            delete state[AccountId];
                        }
                    }
                } else {
                    if (!state[AccountId]) state[AccountId] = {};
                    if (!state[AccountId][AccountWithdrawalDataId]) {
                        state[AccountId][AccountWithdrawalDataId] = action.payload;
                    } else {
                        Object.assign(state[AccountId][AccountWithdrawalDataId], action.payload);
                    }
                }
            });
    }
});

export default accountsWithdrawalRelationshipsSlice.reducer;